if (!customElements.get('recently-viewed-products')) {
  const STORAGE_KEY = 'recentlyViewedProducts';
  const MAX_STORED  = 20;
  const MAX_SHOWN   = 8;
  const BANNED_TAGS = ['base-product', 'hide-product', 'hide_product'];

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      const handle = this.dataset.productHandle;
      this._track(handle);

      const handles = this._getHandles().filter(h => h !== handle);
      if (!handles.length) { this._hide(); return; }

      this._inject(handles);
    }

    _track(handle) {
      if (!handle) return;
      const existing = this._getHandles().filter(h => h !== handle);
      const updated = [handle, ...existing].slice(0, MAX_STORED);
      try { localStorage.setItem(STORAGE_KEY, updated.join(',')); } catch {}
    }

    _getHandles() {
      try {
        return [...new Set((localStorage.getItem(STORAGE_KEY) || '').split(',').filter(Boolean))];
      } catch { return []; }
    }

    _inject(handles) {
      const container = this.closest('swiper-container');
      if (!container) { this._hide(); return; }

      Promise.all(handles.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(r => r.ok ? r.json() : null)
          .then(product => (product && product.available) ? handle : null)
          .catch(() => null)
      )).then(results => {
        const available = results.filter(Boolean);
        if (!available.length) { this._hide(); return; }

        const appendSlides = () => {
          if (!container.swiper) {
            requestAnimationFrame(appendSlides);
            return;
          }

          const shown = available.slice(0, MAX_SHOWN);
          shown.forEach(handle => {
            const slide = document.createElement('swiper-slide');
            slide.innerHTML = `<intersection-loader data-url="/products/${handle}" data-section-id="product-card"></intersection-loader>`;
            container.swiper.appendSlide(slide);
          });

          this.closest('.shopify-section')?.style.setProperty('display', 'block');
          this.remove();
        };

        appendSlides();
      });
    }

    _hide() {
      this.closest('.shopify-section')?.remove();
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
